import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { VendorInfo } from "../../../SchemaInfo/info";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { VendorSchema } from "../../../Schemas/purchase/vendor.schema";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { toTitleCase } from "../../../Components/Functions/word.fun";

const AddVendor = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  useEffect(() => {
    performRequest("GET", "/materialPlanning/getAllMaterialList")
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.MaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  // 🔍 Filter vendor items
  const filteredData = data
    ?.slice()
    .sort((a, b) => {
      if (a.item === "Other Items") return 1;
      if (b.item === "Other Items") return -1;
      return 0;
    })
    .filter((val) => val.item.toLowerCase().includes(searchTerm.toLowerCase()));

  const handelSubmit = (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].trim();
      }
    });
    values = {
      ...values,
      generatedBy: userData?.Name,
      businessAddress: toTitleCase(values.businessAddress),
      businessName: toTitleCase(values.businessName),
      state: toTitleCase(values.state),
      bankName: toTitleCase(values.bankName),
      contactPersonName: toTitleCase(values.contactPersonName),
    };

    let formData = new FormData();
    for (let key in values) {
      if (values.hasOwnProperty(key)) {
        if (Array.isArray(values[key])) {
          for (let item of values[key]) {
            formData.append(key, item);
          }
        } else {
          formData.append(key, values[key]);
        }
      }
    }
    // loading true
    setLoading(true);
    const headers = { "Content-Type": "multipart/form-data" };
    performRequest("POST", "/vendor/createVendor", formData, headers)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Vendor created successfully!");
          navigate(`/purchase-vendor-management`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  // if (loading) {
  //   return <LoadingPage />;
  // }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Vendor Management</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">New Vendor</h2>
            </div>

            <Formik
              initialValues={VendorInfo}
              validationSchema={VendorSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Business name
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="businessName" type="text" />
                        {props.touched.businessName &&
                          props.errors.businessName && (
                            <p className="text-danger">
                              {props.errors.businessName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required  col-3">
                        Contact person name
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="contactPersonName" type="text" />
                        {props.touched.contactPersonName &&
                          props.errors.contactPersonName && (
                            <p className="text-danger">
                              {props.errors.contactPersonName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Phone number
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="contactPersonPhone" type="text" />
                        {props.touched.contactPersonPhone &&
                          props.errors.contactPersonPhone && (
                            <p className="text-danger">
                              {props.errors.contactPersonPhone}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Alternative phone number
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="alternateContactPersonPhone"
                          type="text"
                        />
                        {props.touched.alternateContactPersonPhone &&
                          props.errors.alternateContactPersonPhone && (
                            <p className="text-danger">
                              {props.errors.alternateContactPersonPhone}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Business email
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="contactPersonEmail" type="text" />
                        {props.touched.contactPersonEmail &&
                          props.errors.contactPersonEmail && (
                            <p className="text-danger">
                              {props.errors.contactPersonEmail}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Reffered by
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="referredBy" type="text" />
                        {props.touched.referredBy &&
                          props.errors.referredBy && (
                            <p className="text-danger">
                              {props.errors.referredBy}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Business address
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="businessAddress" type="text" />
                        {props.touched.businessAddress &&
                          props.errors.businessAddress && (
                            <p className="text-danger">
                              {props.errors.businessAddress}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        State
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="state" type="text" />
                        {props.touched.state && props.errors.state && (
                          <p className="text-danger">{props.errors.state}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label
                        className={
                          props.values.notHaveGST
                            ? "w-25 form-label col-3"
                            : "w-25 form-label col-3 required"
                        }
                      >
                        Gst number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="gstNumber" />

                        {props.touched.gstNumber && props.errors.gstNumber && (
                          <p className="text-danger">
                            {props.errors.gstNumber}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vendor don't have Gst number
                      </label>
                      <div className="w-100 col">
                        <CustomCheckbox
                          name="notHaveGST"
                          type="checkbox"
                          width={"17px"}
                          height={"17px"}
                        />

                        {props.touched.notHaveGST &&
                          props.errors.notHaveGST && (
                            <p className="text-danger">
                              {props.errors.notHaveGST}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Pan number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="panNumber" />

                        {props.touched.panNumber && props.errors.panNumber && (
                          <p className="text-danger">
                            {props.errors.panNumber}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Bank name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="bankName" />

                        {props.touched.bankName && props.errors.bankName && (
                          <p className="text-danger">{props.errors.bankName}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3  required">
                        Bank account name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="bankAccountName" />

                        {props.touched.bankAccountName &&
                          props.errors.bankAccountName && (
                            <p className="text-danger">
                              {props.errors.bankAccountName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Bank account number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="bankAccountNumber" />

                        {props.touched.bankAccountNumber &&
                          props.errors.bankAccountNumber && (
                            <p className="text-danger">
                              {props.errors.bankAccountNumber}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Bank IFSC
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="bankIFSC" />

                        {props.touched.bankIFSC && props.errors.bankIFSC && (
                          <p className="text-danger">{props.errors.bankIFSC}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment term
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="paymentTerm">
                          <option value="">Select</option>
                          <option value="to pay">To Pay</option>
                          <option value="100% advance">100% Advance</option>
                          <option value="50% advance">50% Advance</option>
                          <option value="30 days">30 Days</option>
                          <option value="45 days">45 Days</option>
                          <option value="60 days">60 Days</option>
                          <option value="As per discussion">
                            As per discussion
                          </option>
                        </CustomSelect>

                        {props.touched.paymentTerm &&
                          props.errors.paymentTerm && (
                            <p className="text-danger">
                              {props.errors.paymentTerm}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Business nature
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="businessNature">
                          <option value="">Select</option>
                          <option value="manufacturer">Manufacturer</option>
                          <option value="wholseller">Wholseller</option>
                          <option value="distributor">Distributor</option>
                          <option value="services">Services</option>
                          <option value="retailer">Retailer</option>
                          <option value="broker">Broker</option>
                          <option value="transporter">Transporter</option>
                        </CustomSelect>

                        {props.touched.businessNature &&
                          props.errors.businessNature && (
                            <p className="text-danger">
                              {props.errors.businessNature}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Legal constitution
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="legalConstitution">
                          <option value="">Select</option>
                          <option value="individual">Individual</option>
                          <option value="huf">HUF</option>
                          <option value="partnership">Partnership</option>
                          <option value="pvtLtd">PVT Ltd</option>
                          <option value="other">Other</option>
                        </CustomSelect>

                        {props.touched.legalConstitution &&
                          props.errors.legalConstitution && (
                            <p className="text-danger">
                              {props.errors.legalConstitution}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Accepted payment mode
                      </label>
                      <div className="w-100 col">
                        <div>
                          <label className="form-check form-check-inline">
                            <CustomCheckbox
                              type="checkbox"
                              width={"25px"}
                              name="acceptedPaymentMode"
                              value="NEFT"
                            />
                            <span className="form-check-label">NEFT</span>
                          </label>

                          <label className="form-check form-check-inline">
                            <CustomCheckbox
                              name="acceptedPaymentMode"
                              value="RTGS"
                              type="checkbox"
                              width={"25px"}
                            />
                            <span className="form-check-label">RTGS</span>
                          </label>
                          <label className="form-check form-check-inline">
                            <CustomCheckbox
                              type="checkbox"
                              width={"25px"}
                              name="acceptedPaymentMode"
                              value="cheque"
                            />
                            <span className="form-check-label">Cheque</span>
                          </label>
                          <label className="form-check form-check-inline">
                            <CustomCheckbox
                              type="checkbox"
                              width={"25px"}
                              name="acceptedPaymentMode"
                              value="cash"
                            />
                            <span className="form-check-label">Cash</span>
                          </label>
                        </div>

                        {props.touched.acceptedPaymentMode &&
                          props.errors.acceptedPaymentMode && (
                            <p className="text-danger">
                              {props.errors.acceptedPaymentMode}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Notes</label>

                      <div className="w-100 col">
                        <CustomTextArea type="text" name="notes" />

                        {props.touched.notes && props.errors.notes && (
                          <p className="text-danger">{props.errors.notes}</p>
                        )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Vendor deals in
                      </label>
                      <div
                        className="w-100 col border m-2 p-2"
                        style={{ height: "400px", overflow: "scroll" }}
                      >
                        {data
                          ?.slice()
                          .sort((a, b) => {
                            if (a.item === "Other Items") return 1;
                            if (b.item === "Other Items") return -1;
                            return 0;
                          })
                          .map((val, index) => {
                            return (
                              <div key={index}>
                                <div>
                                  <div className="d-flex">
                                    <label className="form-check-inline">
                                      <CustomCheckbox
                                        type="checkbox"
                                        width={"15px"}
                                        height={"15px"}
                                        name="vendorDealsIn"
                                        value={`${val.id}`}
                                      />
                                    </label>
                                    <span className="form-check-label">
                                      {val.item}
                                    </span>
                                  </div>
                                  {props.values.vendorDealsIn &&
                                    props.values.vendorDealsIn.includes(
                                      `${val.item}`
                                    )}
                                </div>
                                {props.touched.vendorDealsIn &&
                                  props.errors.vendorDealsIn && (
                                    <p className="text-danger">
                                      {props.errors.vendorDealsIn}
                                    </p>
                                  )}
                              </div>
                            );
                          })}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Vendor deals in
                      </label>
                      <div className="w-100 col">
                        <div
                          className="border m-2 p-2 rounded"
                          style={{ height: "400px", overflowY: "auto" }}
                        >
                          {/* 🔍 Search Input */}
                          <div className="mb-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search product..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>

                          {/* 🧾 Product List */}
                          {filteredData && filteredData.length > 0 ? (
                            filteredData.map((val, index) => (
                              <div
                                key={index}
                                className="d-flex align-items-center mb-1"
                              >
                                <label className="form-check-inline m-0">
                                  <CustomCheckbox
                                    type="checkbox"
                                    width={"15px"}
                                    height={"15px"}
                                    name="vendorDealsIn"
                                    value={`${val.id}`}
                                  />
                                </label>
                                <span className="form-check-label ms-2">
                                  {val.item}
                                </span>
                              </div>
                            ))
                          ) : (
                            <p className="text-muted text-center mt-3">
                              No matching products
                            </p>
                          )}

                          {/* Validation message */}
                        </div>
                        {props.touched.vendorDealsIn &&
                          props.errors.vendorDealsIn && (
                            <p className="text-danger mt-2">
                              {props.errors.vendorDealsIn}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Custom vendor deals
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="customDeal" />

                        {props.touched.customDeal &&
                          props.errors.customDeal && (
                            <p className="text-danger">
                              {props.errors.customDeal}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label
                        className={
                          props.values.notHaveGST
                            ? "w-25 form-label col-3"
                            : "w-25 form-label col-3 required"
                        }
                      >
                        GST certificate
                      </label>
                      <div className="w-100 col">
                        {" "}
                        <CustomInput
                          onChange={(e) =>
                            props.setFieldValue(
                              "gstCertificate",
                              e.target.files[0]
                            )
                          }
                          name="gstCertificate"
                          type="file"
                        />
                        {props.touched.gstCertificate &&
                          props.errors.gstCertificate && (
                            <p className="text-danger">
                              {props.errors.gstCertificate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Vendor registration
                      </label>
                      <div className="w-100 col">
                        {" "}
                        <CustomInput
                          onChange={(e) =>
                            props.setFieldValue("vendorReg", e.target.files[0])
                          }
                          name="vendorReg"
                          type="file"
                        />
                        {props.touched.vendorReg && props.errors.vendorReg && (
                          <p className="text-danger">
                            {props.errors.vendorReg}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Vendor bank passbook
                      </label>
                      <div className="w-100 col">
                        {" "}
                        <CustomInput
                          onChange={(e) =>
                            props.setFieldValue(
                              "vendorBankPassbook",
                              e.target.files[0]
                            )
                          }
                          name="vendorBankPassbook"
                          type="file"
                        />
                        {props.touched.vendorBankPassbook &&
                          props.errors.vendorBankPassbook && (
                            <p className="text-danger">
                              {props.errors.vendorBankPassbook}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Vendor agreement
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          onChange={(e) =>
                            props.setFieldValue(
                              "vendorAgreement",
                              e.target.files[0]
                            )
                          }
                          name="vendorAgreement"
                          type="file"
                        />
                        {props.touched.vendorAgreement &&
                          props.errors.vendorAgreement && (
                            <p className="text-danger">
                              {props.errors.vendorAgreement}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create Vendor" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default AddVendor;
